import React from 'react';
import { Link, NavLink } from 'react-router-dom';
import DashboardOutlined from '@mui/icons-material/DashboardOutlined';
import PeopleOutline from '@mui/icons-material/PeopleOutline';
import MedicalServicesOutlined from '@mui/icons-material/MedicalServicesOutlined';
import EventNoteOutlined from '@mui/icons-material/EventNoteOutlined';
import ArrowOutward from '@mui/icons-material/ArrowOutward';
import Close from '@mui/icons-material/Close';
import LocalHospitalOutlined from '@mui/icons-material/LocalHospitalOutlined';

const links = [
    { to: '/dashboard', label: 'Dashboard', Icon: DashboardOutlined },
    { to: '/doctors', label: 'Doctors', Icon: MedicalServicesOutlined },
    { to: '/patients', label: 'Patients', Icon: PeopleOutline },
    { to: '/visits', label: 'Visits', Icon: EventNoteOutlined },
];

export default function Sidebar({ open, onClose }) {
    return <aside className={`staff-sidebar ${open ? 'is-open' : ''}`} id="staff-navigation">
        <div className="staff-brand-row"><Link to="/dashboard" className="staff-brand" aria-label="Horizont Clinic dashboard"><span className="staff-logo-window"><img src="/horizont-clinic.png" alt="Horizont Clinic" /></span></Link><button className="staff-mobile-close" onClick={onClose} aria-label="Close navigation"><Close /></button></div>
        <p className="staff-sidebar-label">WORKSPACE</p>
        <nav aria-label="Staff navigation">{links.map(({ to, label, Icon }) => <NavLink key={to} to={to} onClick={onClose} className={({ isActive }) => `staff-nav-link ${isActive ? 'is-active' : ''}`}><Icon /><span>{label}</span><span className="staff-nav-dot" /></NavLink>)}</nav>
        <div className="staff-sidebar-bottom"><div className="staff-care-note"><LocalHospitalOutlined /><p>A little more care.<br /><strong>A better horizon.</strong></p><span>Every patient. Every visit.</span></div><Link className="staff-public-link" to="/">Visit clinic website <ArrowOutward /></Link><div className="staff-sidebar-signature"><span className="staff-status-dot" /> HORIZONT CLINIC</div></div>
    </aside>;
}
